import React from 'react';
import { Pagination } from 'antd';
// Types
import { SearchCampaignStores_searchCampaignStores_entities } from 'api/campaignV2/types/SearchCampaignStores';
import { SearchSocialShareCampaignStores_searchSocialShareCampaignStores_entities } from 'api/campaignV2/types/SearchSocialShareCampaignStores';
import { SearchSocialBoostCampaignStores_searchSocialBoostCampaignStores_entities } from 'api/campaignV2/types/SearchSocialBoostCampaignStores';
import { SearchCustomStores_searchCustomStores_entities } from 'api/campaignV2/types/SearchCustomStores';
// Helpers
import { formatAudienceSize } from 'helpers/campaignEditModal';
// Component
import TalentItem from '../TalentItem/TalentItem';
// Styles
import styles from './TalentList.module.scss';

type TalentListProps = {
  talents:
    | SearchCampaignStores_searchCampaignStores_entities[]
    | SearchSocialShareCampaignStores_searchSocialShareCampaignStores_entities[]
    | SearchSocialBoostCampaignStores_searchSocialBoostCampaignStores_entities[]
    | SearchCustomStores_searchCustomStores_entities[];
  hasMore: boolean;
  totalTalents: number;
  totalFollowers: number;
  // this is only used for Book me campaigns
  // when it's used as a flag, it's to check if something is (not) needed for Book me campaigns
  onSelectTalent?: (talentId: string) => void;
  // Book Me talent list pagination props
  currentPage?: number;
  pageSize?: number;
  showPagination?: boolean;
  selectedTalentId?: string | null;
};

const TalentList = ({
  talents,
  hasMore,
  totalTalents,
  totalFollowers,
  onSelectTalent,
  currentPage = 1,
  pageSize = 8,
  showPagination = false,
  selectedTalentId,
}: TalentListProps): JSX.Element | null => {
  return (
    <div className={styles.root}>
      {hasMore && !onSelectTalent && (
        <div className={styles.following}>
          {totalTalents} matches for your criteria with{' '}
          {formatAudienceSize((totalFollowers ?? 0).toString(), 1)} combined
          following
        </div>
      )}

      <div className={styles.itemWrapper}>
        {talents?.map((talent) => (
          <TalentItem
            key={talent.id}
            talent={talent}
            onSelectTalent={onSelectTalent}
            selectedTalentId={selectedTalentId}
          />
        ))}
      </div>

      {/* pagination for book me campaigns */}
      {showPagination && onSelectTalent && totalTalents > pageSize && (
        <div className={styles.paginationWrapper}>
          <Pagination
            current={currentPage}
            pageSize={pageSize}
            total={totalTalents}
            showSizeChanger={false}
            showTotal={(total, range) =>
              `${range[0]}-${range[1]} of ${total} talents`
            }
          />
        </div>
      )}
    </div>
  );
};

export default TalentList;
